import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "utils/api";
import toast from "react-hot-toast";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import {
    MdArrowBack,
} from "react-icons/md";


delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export default function RunnerDetails() {
    const { runnerId } = useParams();
    const [runner, setRunner] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        loadRunner();
    }, [runnerId]);

    const loadRunner = async () => {
        try {
            const res = await api.post(`/get_user`, { user_id: runnerId });
            setRunner(res.data);
        } catch (err) {
            console.error(err);
            toast.error("Failed to load runner details");
        }
    };

    if (!runner) {
        return <div className="p-6 text-center text-gray-500">Loading...</div>;
    }

    const hasLocation = runner.latitude != null && runner.longitude != null;
    const runnerPos = hasLocation ? [Number(runner.latitude), Number(runner.longitude)] : null;

    return (
        <div className="p-6 space-y-6">
            <div className="rounded-xl bg-white p-6 shadow-md transition-shadow duration-300 hover:shadow-xl">
                <div className="flex items-center gap-3">
                    <button
                        onClick={(o) => navigate(`/admin/runner_details/589733e6-4520-4d29-8387-558f47f209da`)}
                        className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 shadow-sm transition hover:border-gray-300 hover:bg-gray-50"
                        aria-label="Back to Runner Boys"
                    >
                        <MdArrowBack className="h-5 w-5" />
                    </button>
                </div>
                <h2 className="text-2xl font-bold mb-6 text-center">Runner Details</h2>
                <table className="min-w-full divide-y divide-gray-200">
                    <tbody className="bg-white divide-y divide-gray-200">
                        <tr>
                            <td className="px-6 py-4 font-semibold text-gray-700">ID</td>
                            <td className="px-6 py-4">{runner.id}</td>
                        </tr>
                        <tr>
                            <td className="px-6 py-4 font-semibold text-gray-700">Name</td>
                            <td className="px-6 py-4">{runner.name}</td>
                        </tr>
                        <tr>
                            <td className="px-6 py-4 font-semibold text-gray-700">Email</td>
                            <td className="px-6 py-4">{runner.email}</td>
                        </tr>
                        <tr>
                            <td className="px-6 py-4 font-semibold text-gray-700">Role</td>
                            <td className="px-6 py-4">{runner.role === "R" ? "Runner Boy" : runner.role}</td>
                        </tr>
                        <tr>
                            <td className="px-6 py-4 font-semibold text-gray-700">Status</td>
                            <td className="px-6 py-4">{runner.status === 1 ? "Active" : "Inactive"}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {runnerPos && (
                <div className="rounded-xl bg-white overflow-hidden shadow-md">
                    <div className="flex items-center justify-between gap-2 border-b border-gray-100 bg-gray-50/80 px-4 py-3">
                        <span className="text-sm font-medium text-gray-600">Runner last location</span>
                        {runner.last_updated && (
                            <span className="text-xs text-emerald-600 font-medium bg-emerald-50 px-2 py-1 rounded">
                                Updated {new Date(runner.last_updated).toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit", second: "2-digit" })}
                            </span>
                        )}
                    </div>
                    <div className="h-[280px] w-full">
                        <MapContainer
                            center={runnerPos}
                            zoom={14}
                            style={{ height: "100%", width: "100%" }}
                        >
                            <TileLayer
                                url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                                attribution='&copy; OpenStreetMap &copy; CartoDB'
                            />
                            <Marker position={runnerPos}>
                                <Popup>Runner</Popup>
                            </Marker>
                        </MapContainer>
                    </div>
                </div>
            )}
        </div>
    );
}
